const Footer = () => {
  return (
    <h4 className="p-10 text-center bg-orange-50">
      This site is developed by{" "}
      <a
        className="text-red-400"
        href="https://www.linkedin.com/in/nidhig30/"
        target="_blank"
      >
        Nidhi Gadge
      </a>
    </h4>
  );
};

export default Footer;
